


































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import EditorComponent from './EditorComponent.vue'
import PreviewComponent from './PreviewComponent.vue'
import EditorToolbarComponent from './EditorToolbarComponent.vue'
import NavigatorComponent from './NavigatorComponent.vue'
import MetadataComponent from './MetadataComponent.vue'
import { Multipane, MultipaneResizer } from 'vue-multipane'
import SidebarMenuComponent from './SidebarMenuComponent.vue'
import ComparisonComponent from './ComparisonComponent.vue'
import RevisionComponent from './RevisionComponent.vue'
import { IExam } from '../../../types'
import { State, Getter, Action, Mutation } from '../store-helper'
import { EDITOR_MODE } from '../stores/types'
import { qEditorState } from '../stores'
import MathLive from './MathLiveComponent.vue'
import api from '../../api/v2/api';
import ExamGenerationForm from '../../api/v2/forms/exam_generation'
import { makeChannel } from '../../../action_cable/cable'

@Component({
  components: {
    EditorComponent,
    EditorToolbarComponent,
    NavigatorComponent,
    PreviewComponent,
    SidebarMenuComponent,
    ComparisonComponent,
    RevisionComponent,
    Multipane,
    MultipaneResizer,
    MathLive
  }
})
export default class QuestionEditorComponent extends Vue {
  get exam(){
    return qEditorState.exam
  }

  get isEditorMode(){
    return qEditorState.isEditorMode
  }

  get isRevisionMode(){
    return qEditorState.isRevisionMode
  }

  constructor() {
    super()
  }

  created() {
    qEditorState.loadData()
  }

  saveFromShortcut(event) {
    if (window.navigator.platform.toUpperCase().indexOf('MAC') >= 0 && event.srcKey == 'mac') {
      this.save()
    } else if (window.navigator.platform.toUpperCase().indexOf('MAC') < 0 && event.srcKey == 'other') {
      this.save()
    }
  }

  save() {
    if (this.isEditorMode) {
      qEditorState.saveQuestions()
    }
  }
}
